/* Hero3ColumnLayout.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _30 = "@media (min-width:64rem){._10jx1ccs{max-width:35rem}}";
const _29 = "@media (min-width:64rem){._3p1cv47k{font-size:var(--ds-space-250,20px)}}";
const _28 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _27 = "._1wyb1cby{font-size:1.125rem}";
const _26 = "._k48p1nn1{font-weight:400}";
const _25 = "._ect41roz{font-family:var(--ds-font-family-brand-heading,\"Charlie Display\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _24 = "._19pkidpf{margin-top:0}";
const _23 = "._1ygb1a9f:focus-visible{outline:var(--_1kmg6zk)}";
const _22 = "._y3gn1h6o{text-align:center}";
const _21 = "._k48p1fw0{font-weight:700}";
const _20 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _19 = "@media (min-width:64rem){._isu4xncg{margin-bottom:var(--ds-space-800,4pc)}}";
const _18 = "._2lx21bp4{flex-direction:column}";
const _17 = "@media not all and (min-width:64rem){._1s4p1osq{width:100%}._sp8t1jfw{padding-left:var(--ds-space-500,40px)}._axwi1jfw{padding-right:var(--ds-space-500,40px)}}";
const _16 = "@media not all and (min-width:48rem){._1rfm1osq{width:100%}._1mae1ejb{padding-left:var(--ds-space-300,24px)}._1ggm1ejb{padding-right:var(--ds-space-300,24px)}}";
const _15 = "._1bah1h6o{justify-content:center}";
const _14 = "._zulp1nde{gap:var(--ds-space-400,24px)}";
const _13 = "@keyframes fadeIn{0%{opacity:0}to{opacity:1}}";
const _12 = "._tzy4idpf{opacity:0}";
const _11 = "._y44v17nv{animation:fadeIn .5s ease-in-out forwards}";
const _10 = "@media not all and (min-width:90rem){._zzrme2i8{width:23.375rem}}";
const _9 = "._1bsba8ze{width:27.5rem}";
const _8 = "@media (min-width:48rem) and (max-width:63.99rem){._1gzv1jfw{gap:var(--ds-space-500,40px)}._1m491h6o{justify-content:center}._55br1bp4{flex-direction:column}._i6jx1jfw{padding-top:var(--ds-space-500,40px)}}";
const _7 = "@media not all and (min-width:48rem){._8164xy5q{gap:var(--ds-space-400,2pc)}._nssp1h6o{justify-content:center}._1gde1bp4{flex-direction:column}._1kmx1ejb{padding-top:var(--ds-space-300,24px)}}";
const _6 = "._1bah1yb4{justify-content:space-between}";
const _5 = "._2lx2vrvc{flex-direction:row}";
const _4 = "._1wpz1fhb{align-self:stretch}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { xcss } from '@atlaskit/primitives';
import { Hide, media, Show } from '@atlaskit/primitives/responsive';
import { BodyNormal, H1 } from '@atlassian/mpac-primitives';
import { SearchEmbedded } from '@atlassian/mpac-search';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._1bsb1osq{width:100%}";
const fadeInAnimation = null;
const HeroWrapperBodyStyle = null;
const HeroImageContainerStyle = xcss({
  width: '100%',
  height: 'auto',
  objectFit: 'contain'
});
const HeroImageDesktopStyle = null;
const HeroImageStyle = null;
const HeroImageDesktopContainerStyle = null;
const HeroInnerStyle = null;
const ContentSearchContainerStyle = null;
const ProductHeroInnerStyle = null;
const HeadingStyle = null;
const DescriptionStyle = null;
const SearchWrapperStyle = null;
const Search = forwardRef((_ref, __cmplr) => {
  let {
      as: C = SearchEmbedded,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Search.displayName = 'Search';
}
export const Hero3ColumnLayout = _ref2 => {
  let {
    heading,
    description,
    isSearchBarIncluded,
    heroDesktopLeftImage,
    heroDesktopRightImage,
    heroTabletImage,
    heroMobileImage,
    additionalQueryParams,
    searchPlaceholder,
    productName,
    setFocusOnHeading,
    redirectUrl,
    onBannerClick,
    onKeyDownBanner
  } = _ref2;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4, _5, _6, _, _7, _8]
    }), /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
      "data-testid": "hero-3column-layout"
    }, redirectUrl && !isSearchBarIncluded && {
      role: 'button',
      tabIndex: 0,
      onClick: e => onBannerClick(e, redirectUrl),
      onKeyDown: e => onKeyDownBanner(e, redirectUrl)
    }), {}, {
      className: ax(["_1e0c1txw _4cvr1h6o _1wpz1fhb _2lx2vrvc _1bah1yb4 _1bsb1osq _8164xy5q _nssp1h6o _1gde1bp4 _1kmx1ejb _1gzv1jfw _1m491h6o _55br1bp4 _i6jx1jfw"]),
      children: [/*#__PURE__*/_jsx(Hide, {
        below: "md",
        children: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_9, _10]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsba8ze _zzrme2i8"]),
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_11, _12, _, _13]
              }), /*#__PURE__*/_jsx("img", {
                alt: "",
                src: heroDesktopLeftImage,
                className: ax(["_y44v17nv _tzy4idpf _1bsb1osq", "_y44v17nv"])
              })]
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_14, _2, _3, _15, _4, _16, _17]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_zulp1nde _1e0c1txw _4cvr1h6o _1bah1h6o _1wpz1fhb _1rfm1osq _1mae1ejb _1ggm1ejb _1s4p1osq _sp8t1jfw _axwi1jfw"]),
          children: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_2, _, _15, _18, _3, _19]
            }), /*#__PURE__*/_jsxs("div", {
              className: ax(["_1e0c1txw _1bsb1osq _1bah1h6o _2lx21bp4 _4cvr1h6o", productName && "_isu4xncg"]),
              children: [heading && /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_20, _21, _22, _, _4, _23]
                }), /*#__PURE__*/_jsx(H1, {
                  tabIndex: -1,
                  ref: setFocusOnHeading,
                  className: ax(["_otyru2gc _k48p1fw0 _y3gn1h6o _1bsb1osq _1wpz1fhb _1ygb1a9f"]),
                  style: {
                    "--_1kmg6zk": ix("var(--ds-space-025, 2px)".concat(" solid ", "var(--ds-border-focused, #388BFF)"))
                  },
                  children: heading
                })]
              }), description && /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_24, _22, _4, _25, _26, _27, _, _28, _29]
                }), /*#__PURE__*/_jsx(BodyNormal, {
                  className: ax(["_19pkidpf _y3gn1h6o _1wpz1fhb _ect41roz _k48p1nn1 _1wyb1cby _1bsb1osq _otyrxy5q _3p1cv47k"]),
                  children: description
                })]
              }), isSearchBarIncluded && /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_, _30]
                }), /*#__PURE__*/_jsx("div", {
                  className: ax(["_1bsb1osq _10jx1ccs"]),
                  children: /*#__PURE__*/_jsx(Search, {
                    additionalQueryParams: additionalQueryParams,
                    searchPlaceholder: searchPlaceholder
                  })
                })]
              })]
            })]
          })
        })]
      }), /*#__PURE__*/_jsx(Hide, {
        below: "md",
        children: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_9, _10]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsba8ze _zzrme2i8"]),
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_11, _12, _, _13]
              }), /*#__PURE__*/_jsx("img", {
                alt: "",
                src: heroDesktopRightImage,
                className: ax(["_y44v17nv _tzy4idpf _1bsb1osq", "_y44v17nv"])
              })]
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(Show, {
        xcss: HeroImageContainerStyle,
        below: "md",
        children: [/*#__PURE__*/_jsx(Hide, {
          below: "xs",
          children: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_11, _, _12, _13]
            }), /*#__PURE__*/_jsx("img", {
              alt: "",
              src: heroTabletImage,
              className: ax(["_y44v17nv _1bsb1osq _tzy4idpf", "_y44v17nv"])
            })]
          })
        }), /*#__PURE__*/_jsx(Show, {
          xcss: HeroImageContainerStyle,
          below: "xs",
          children: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_11, _, _12, _13]
            }), /*#__PURE__*/_jsx("img", {
              alt: "",
              src: heroMobileImage,
              className: ax(["_y44v17nv _1bsb1osq _tzy4idpf", "_y44v17nv"])
            })]
          })
        })]
      })]
    }))]
  });
};